import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Mapboxpage from "../Mapboxpage";
import check from "../images/icons8-checkmark-150.png";
import event from "../images/icons8-event-accepted-100.png";
import quality from "../images/icons8-quality-100.png";
import { db } from '../../firebase-config';
import { collection, getDocs, query, where } from 'firebase/firestore';
import CircularProgress from "@mui/material/CircularProgress";

const Chauffertransfer = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const [Chauffertransfersservices, ChauffertransfersServices] = useState([]);
  const headerData = Chauffertransfersservices[0];
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "chauffers")
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        ChauffertransfersServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // ✅ important
      }
    };

    fetchServices();
  }, []);

  // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }

  return (
    <>
 <div
        className="mainhero-container"
        style={{
          backgroundImage: `url(${headerData?.headerimage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="mainhero-content">
          {/* <h1>
   <span style={{ color: "#45B2F7" }}>Luxury</span> Airport Transfers Service
 </h1> */}
          <h1>
            <span style={{ color: "#45B2F7" }}>
              {headerData?.headerTitle?.split(" ")[0] || "Luxury"}
            </span>{" "}
            {headerData?.headerTitle?.split(" ").slice(1).join(" ") || "Chauffeur Transfer Services"}
          </h1>
          <p>
            {headerData?.headerDescription || "Experience premium chauffeur-driven travel with comfort, style, and professionalism. Our expert drivers ensure a smooth, safe, and luxurious journey for business, events, and city rides."}

          </p>
        </div>
        <Mapboxpage />
      </div>
      <br />

      {/* INFO CARDS */}
      <div className="cards-containerairport">

        <div className="info-card">
          <div className="card-text">
            <img src={check} alt="service" className="card-logo" />
            <br />
            <h3>Premium Arrival Assistance</h3>
            <p>
              Experience a smooth and stress-free journey with MAS Mobility
              Services’ professional chauffeur services. Our experienced
              chauffeurs arrive on time, assist with luggage handling, and
              ensure a comfortable pickup and drop-off experience tailored to
              your travel needs. From airport arrivals to business meetings,
              every ride is managed with professionalism and care.
            </p>
          </div>
        </div>

        <div className="info-card">
          <div className="card-text">
            <img src={event} alt="service" className="card-logo" />
            <br />
            <h3>Flexible & Reliable Chauffeur Service</h3>
            <p>
              MAS Mobility Services provides flexible chauffeur transportation
              designed around your schedule. Whether your plans change at the
              last minute or you require additional travel arrangements, our
              dedicated team ensures dependable and convenient service with
              maximum comfort, privacy, and reliability throughout your journey.
            </p>
          </div>
        </div>

        <div className="info-card">
          <div className="card-text">
            <img src={quality} alt="service" className="card-logo" />
            <br />
            <h3>Luxury Travel with Transparent Pricing</h3>
            <p>
              Enjoy premium chauffeur-driven transportation with MAS Mobility
              Services at competitive and transparent pricing. Our services
              combine luxury vehicles, skilled chauffeurs, and high-quality
              customer care to deliver a first-class travel experience without
              hidden charges, ensuring comfort and value on every trip.
            </p>
          </div>
        </div>

      </div>
      <br />

      {/* SERVICES SECTION */}
      <div>
        {loading ? (
          <div className="skeleton-card">loading ....</div>
        ) : Chauffertransfersservices?.length === 0 ? (
          <h2 style={{ textAlign: "center" }}>No data found</h2>
        ) : (
          Chauffertransfersservices?.map((service, index) => (
            <div
              key={service.id}
              className={`service-section ${index % 2 !== 0 ? "reverse" : ""
                }`}
            >
              {/* IMAGE */}
              <div
                className="service-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <img src={service.image} alt={service.description} />
              </div>

              {/* CONTENT */}
              <div className="service-content">
                <h2>{service.description}</h2>

                <ul className="service-list">
                  {service?.content
                    ?.split(".")
                    .filter((item) => item.trim() !== "")
                    .map((item, index) => (
                      <li key={index}>
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              </div>

            </div>
          ))
        )}
      </div>


    </>
  );
};

export default Chauffertransfer;